export default __webpack_public_path__ + "8a45f260da099988312b6016b9e82f5f.png";